module.exports = __webpack_public_path__ + "static/career-men-2016f320d0ca66e50dc998a0ab28e258.png";